import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import QuestTypeIcon from './QuestTypeIcon'

const QuestTypeIconWrapper = styled.div`
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
`

const QuestIconComponent = styled.div`
  background: ${props => (props.icon_image_url ? '' : '#333333')};
  background-image: ${props =>
    props.icon_image_url ? `url(${props.icon_image_url})` : ''};
  height: ${props => props.heightWidth}px;
  width: ${props => props.heightWidth}px;
  border-radius: 50%;
  background-size: 100%;
  background-repeat: no-repeat;
  border: 1px solid #dedfe0;
  display: ${props => props.display};
`

const QuestIcon = props => (
  <div style={{ position: 'relative', display: 'flex' }}>
    <QuestIconComponent
      className="quest-icon"
      {...props}
      onClick={props.handleClick}
      data-id={props.dataId}
    />
    {props.showTypeIcon && (
      <QuestTypeIconWrapper className="quest-type-icon-wrapper">
        <QuestTypeIcon id={props.questTypeId} size={props.questTypeIconSize} />
      </QuestTypeIconWrapper>
    )}
  </div>
)

QuestIcon.propTypes = {
  icon_image_url: PropTypes.string,
  heightWidth: PropTypes.number,
  display: PropTypes.string,
  handleClick: PropTypes.func,
  dataId: PropTypes.string,
  showTypeIcon: PropTypes.bool,
  questTypeIconSize: PropTypes.number,
  questTypeId: PropTypes.number
}

QuestIcon.defaultProps = {
  heightWidth: 50,
  display: 'inline-block'
}

export default QuestIcon



// WEBPACK FOOTER //
// ./src/components/mini/QuestIcon.js